import { BadgeWithStatus } from '@property.com.au/ui-kit';
import { PCABadgeVariant } from '@property.com.au/ui-kit/dist/types/libraries/prop-ui/public/construct-kit/components/Badge/Badge';
import { ComponentProps } from 'react';

export const mapPropertyStatusToBadgeWithStatus = (
  status: 'for_sale' | 'for_rent' | 'off_market' | 'sold',
): { text: string; variant: ComponentProps<typeof BadgeWithStatus>['variant'] } => {
  switch (status) {
    case 'for_sale':
      return {
        text: 'For sale',
        variant: 'negative',
      };
    case 'for_rent':
      return {
        text: 'For rent',
        variant: 'information',
      };
    case 'sold':
      return {
        text: 'Sold',
        variant: 'warning',
      };

    default:
      return {
        text: 'Off market',
        variant: 'neutral',
      };
  }
};

export const mapPropertyStatusToBadge = (
  status: 'for_sale' | 'for_rent' | 'off_market' | 'sold',
): { text: string; variant: PCABadgeVariant } => {
  switch (status) {
    case 'for_sale':
      return {
        text: 'For sale',
        variant: 'green',
      };
    case 'for_rent':
      return {
        text: 'For rent',
        variant: 'blue',
      };
    case 'sold':
      return {
        text: 'Sold',
        variant: 'red',
      };

    default:
      return {
        text: 'Off market',
        variant: 'grey',
      };
  }
};
